const getDoctorAssignedNameFromCaseDetails = case_details => {
  return `${case_details.doctor.first_name} ${case_details.doctor.last_name}`;
};

const getDoctorAssignedIdFromCaseDetails = case_details => {
  return case_details.doctor.id;
};

export { getDoctorAssignedNameFromCaseDetails, getDoctorAssignedIdFromCaseDetails };
